import { useMutation } from '@tanstack/react-query'
import { serverURL } from '../api/config'

export interface DuplicateCheckResult {
  exists: boolean
  org_name: string | null
  org_uuid: string | null
  has_sub_orgs: boolean | null
}

export function useCheckDuplicate() {
  return useMutation({
    mutationFn: async ({
      token,
      params,
    }: {
      token: string
      params: { charities_number?: string; name?: string }
    }): Promise<DuplicateCheckResult> => {
      const query = new URLSearchParams()
      if (params.charities_number) query.set('charities_number', params.charities_number)
      if (params.name) query.set('name', params.name)

      const response = await fetch(
        `${serverURL}/onboarding-progress/check-duplicate?${query}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )

      if (!response.ok) {
        // Fail-open: return "no duplicate" on any error
        return { exists: false, org_name: null, org_uuid: null, has_sub_orgs: null }
      }

      return response.json()
    },
  })
}
